import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ArrowButton from '../../common/button-arrow';

class ExpandMore extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandMore: false,
        }
    }

    handleExpandMore = () => {
        this.setState({
            expandMore: !this.state.expandMore
        })
    }

    render() {
        const { isStoreButtonHide } = this.props;
        
        return (
        <div>
            <div className="incentives-row more-information-container">
                { this.props.points_per_pack_visible &&
                    <div className="more-information" onClick={() => this.handleExpandMore()}>
                        <i className={this.state.expandMore ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} style={{marginRight: '16px'}} /><p style={{margin: 0}}>More Information</p>
                    </div>
                }
                {!isStoreButtonHide &&
                    <Link to={`/store-details/${this.props.outlet_id}`} className="my-store-link">
                        <ArrowButton arrow={false} color='white' submit={false}>MY STORE</ArrowButton>
                    </Link>
                }
            </div>
            {this.state.expandMore ? (
                this.props.incentive.reward_type == 'points' ? (
                    <div className="incentives-row more-information-row">
                        <div className="more-information-points">
                            <div className="more-information-points-item">
                                <p>Points per pack up to target{this.props.incentive.points_to_target_2 ? ' 1' : null}</p>
                                <p>{this.props.incentive.points_to_target}</p>
                            </div>
                            {this.props.incentive.points_to_target_2 ? (
                                <div className="more-information-points-item">
                                    <p>Points per pack up to target 2</p>
                                    <p>{this.props.incentive.points_to_target_2}</p>
                                </div>
                            ) : null}
                            <div className="more-information-points-item">
                                <p>Points per pack post target{this.props.incentive.points_to_target_2 ? ' 2' : null}</p>
                                <p>{this.props.incentive.points_after_target}</p>
                            </div>
                        </div>
                        <div className="more-information-points">
                            <div className="more-information-points-item">
                                <p>Points earned</p>
                                <p>{this.props.incentive.points_earned}</p>
                            </div>
                            <div className="more-information-points-item">
                                <p>Points awarded</p>
                                <p>{this.props.incentive.points_awarded}</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="incentives-row more-information-prize">
                        <h3>{this.props.incentive.prize_name}</h3>
                        <p>{this.props.incentive.prize_description}</p>
                    </div>
                )
            ) : null}
        </div>
        )
    }
}

export default ExpandMore;


// WEBPACK FOOTER //
// ./src/components/common/store-performances/expand-more.jsx